import SkillTag from '../components/SkillTag';

function Skills() {
  const skills = [
    'HTML5',
    'CSS3',
    'JavaScript (ES6+)',
    'React',
    'Tailwind CSS',
    'CSS Grid',
    'Flexbox',
    'Responsive Design',
    'Git',
    'GitHub',
    'Chrome DevTools',
    'VS Code',
    'Figma',
    'Component-Based Architecture',
    'REST APIs',
    'UI/UX Fundamentals'
  ];

  return (
    <section id="skills" className="py-16 px-4 max-w-4xl mx-auto reveal" aria-labelledby="skills-title" style={{ transitionDelay: '0.12s' }}>
      <h2 id="skills-title" className="text-3xl font-bold mb-8 text-center">Skills</h2>
      <div className="flex flex-wrap justify-center gap-4">
        {skills.map((skill, index) => (
          <SkillTag key={index} skill={skill} />
        ))}
      </div>
    </section>
  );
}

export default Skills;